import React from "react";
// import {predictModels} from "../../../utils/DataModals";
import Icon from "../../../assets/Icon.svg"
import Modal from "./ModelsModal";
import { useState } from "react";

function InactiveModals({filteredData}){

    const [showModal, setshowModal] = useState(false);
    const [modalIndex, setModalIndex] = useState(null);
   
    const openModal = (id) =>{
       // setshowModal(true);
       setModalIndex(id);
    }

    const closeModal = () =>{
        //setshowModal(false);
        setModalIndex(null);
    }

    return(
        <div className="flex flex-wrap">
            
            {/* { predictModels.filter((model) => model.Status === "Inactive").map((data) => { */}
            { filteredData.map((data) => {
                return(
                    <div className="mr-5 p-4 rounded-lg border-solid border-admin-border border-2 bg-th-bg md:mb-3 sm:mb-3 w-[280px] h-[130px]">
                        <div className="flex mb-5 justify-between">
                            <button className="font-medium" onClick={() => openModal(data.id)}>{data.Name}                              
                                <span class="ml-3 bg-bg-danger-btn text-text-danger-btn text-xs font-medium px-2.5 py-0.5 rounded-lg border border-border-danger-btn">
                                    {data.Status}  
                                </span>                                                     
                            </button>
                            <button onClick={() => openModal(data.id)}><img src={Icon} alt="icon"/> </button>
                            <div className="">
                                {modalIndex === data.id && (
                                    <Modal isOpen = {true} onCloseModal = {closeModal} changeState={"Activate"} modelName={data.Name}/> 
                                )}  
                            </div>                         
                        </div>

                        <p className="text-sm font-normal">Created by {data.Model_Creater} on {data.Date}</p>
                    </div>   
                )                        
                } )}           
        </div>
    )

}

export default InactiveModals;